import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink, Navigate, Outlet, Link } from 'react-router-dom';
import Builder from './pages/Builder';
import Explorer from './pages/Explorer';
import Comparator from './pages/Comparator';
import Intro from './pages/Intro';
import './App.css';

// Simple placeholder components for the main pages
const LearnMorePage = () => <div>Learn More Page</div>;
const DocumentationPage = () => <div>Documentation Page</div>;
const DataDownloadPage = () => <div>Data Download Page</div>;


const Header = () => {
  return(
    <header className="main-header">
      <div className="logo">
        <img src="/saws_logo.png" alt="SAWS Logo" />
      </div>
      <nav className="main-nav">
        <NavLink to="/">Home</NavLink>
        <NavLink to="/learn-more">Learn More</NavLink>
        {/*<NavLink to="/tools/explorer">Launch the Tool</NavLink>*/}
        <NavLink to="/documentation">Documentation</NavLink>
        <NavLink to="/data-download">Data Download</NavLink>
      </nav>
    </header>
  )
}

// Tools layout component with tool-specific navigation
const ToolsLayout = () => {
  return (
    <div className="tools-container">
      <nav className="tools-nav">
        {/* Back to Home Link - positioned far left */}
        <div className="left-nav-section">
          <Link to="/" className="back-to-home">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="back-icon">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 8 8 12 12 16"></polyline>
              <line x1="16" y1="12" x2="8" y2="12"></line>
            </svg>
            <span className="back-text">Back to Home</span>
          </Link>
        </div>
        
        {/* Center Nav Section */}
        <div className="center-nav-section">
          <div className="main-links">
            <NavLink to="/tools/explorer" className={({ isActive }) => isActive ? 'active' : ''}>Data Explorer</NavLink>
            <NavLink to="/tools/builder" className={({ isActive }) => isActive ? 'active' : ''}>Map Builder</NavLink>
            <NavLink to="/tools/comparitor" className={({ isActive }) => isActive ? 'active' : ''}>Source Comparison</NavLink>
          </div>
        </div>
        
        {/* Right Nav Section - Empty for balance */}
        <div className="right-nav-section"></div>
      </nav>
      
      <Outlet /> {/* This is where the selected tool component will render */}
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Main routes */}
        <Route path="/" element={
          <>
            <Intro />
          </>
          } />
        <Route path="/learn-more" element={
          <>
            <Header />
            <LearnMorePage />
          </>
          } />
        <Route path="/documentation" element={
          <>
            <Header />
            <DocumentationPage />
          </>
          } />
        <Route path="/data-download" element={
          <>
            <Header />
            <DataDownloadPage />
          </>
          } />
        
        {/* Tool routes with a layout component */}
        <Route path="/tools" element={<ToolsLayout />}>
          <Route index path="explorer" element={<Explorer />} />
          <Route path="builder" element={<Builder />} />
          <Route path="comparitor" element={<Comparator />} />
        </Route>
        
        {/* Default route */}
        <Route path="/" element={<Navigate to="/learn-more" replace />} />
      </Routes>
    </Router>
  );
};

export default App;